export default __webpack_public_path__ + "static/media/circle_graph.15c42254.svg";